import useMutationUserCreateUpdate from './user-use-mutation-create-update';
import useMutationUserSendPass from "./user-use-mutation-send-password";
import useMutationUserDelete from "./user-use-mutation-delete";
import useMutationUserReport from './user-use-mutation-report';


export const userUseMutation = {
  createUpdate: useMutationUserCreateUpdate,
  sendPass: useMutationUserSendPass,
  delete: useMutationUserDelete,
  report: useMutationUserReport,
}